import React from 'react';
import { createPortal } from 'react-dom';
import { bool, element, oneOfType, string, array } from 'prop-types';

const Drawer = ({
  parentId,
  children,
  width,
  open,
}) => {
  return createPortal((
    <div style={{ ...styles.container, display: open ? 'block' : 'none' }}>
      <div
        style={styles.flatLay}
      />
      <div
        style={{
          ...styles.drawer,
          width,
        }}
      >
        {children}
      </div>
    </div>
  ), document.querySelector(`#${parentId}`));
};

Drawer.propTypes = {
  parentId: string.isRequired,
  children: oneOfType([element, string, array]),
  open: bool.isRequired,
  width: string.isRequired,
};

const styles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  drawer: {
    backgroundColor: 'white',
    position: 'absolute',
    height: '100%',
    right: 0,
  },
  flatLay: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    opacity: '0.5',
    backgroundColor: 'black',
  },
};

export default Drawer;
